
import {mapGetters} from 'vuex';
export default {
 data() {
     return {
         ready: false
     }
 },
 computed: {
 ...mapGetters({
   settings: 'settings/settings/settings',
 }),
},
 mounted() {
     setTimeout(() => {
         this.ready = true
     }, 500)
 }
}
